import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalState } from '../../../global.state';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { ToastrService } from 'ngx-toastr';

import { UsersService } from '../../../services';

@Component({
    selector: 'ba-page-top',
    templateUrl: './baPageTop.html',
    styleUrls: ['./baPageTop.scss']
})
export class BaPageTop {
    private id:string = localStorage.getItem('userId');

    public isScrolled:boolean = false;
    public isMenuCollapsed:boolean = false;

    public name:string;
    public image:string;

    constructor(
        private _state:GlobalState,
        private router: Router,
        private slimLoader: SlimLoadingBarService,
        private toastr: ToastrService,
        private usersService: UsersService
    ) {
        this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
            this.isMenuCollapsed = isCollapsed;
        });
        this.getUser();
    }

    public toggleMenu() {
        this.isMenuCollapsed = !this.isMenuCollapsed;
        this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
        return false;
    }

    public scrolledChanged(isScrolled) {
        this.isScrolled = isScrolled;
    }

    public logout() {
        this.usersService.logout().subscribe(
            response => {
                localStorage.clear();
                this.router.navigate(['/login']);
            },
            error => {
                const err = error.json();
                console.log(err);
            },
        );
    }

    public getUser(): void {
        this.usersService.getSingleUser(this.id).subscribe(
            response => {
                if(response.user.profile_image !== null){
                    this.image = response.upload_folder_path + '/' + response.user.profile_image.path;
                } else {
                    this.image = 'assets/img/theme/no-photo.png'
                }
                if(localStorage.getItem('roleName') === 'administrator'){
                    this.name = "Admin";
                } else {
                    this.name = response.user.first_name + ' ' + response.user.last_name;
                }
                this.slimLoader.complete();
            },
            error => {

            },
        );
    }

    changePassword(){
        this.router.navigate(['pages/change-password']);
    }

    editProfile(){
        this.router.navigate(['pages/profile']);
    }
}



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/components/baPageTop/baPageTop.component.ts